module.exports = __webpack_public_path__ + "static/media/waypoint_f.27a18aaf.svg";